import { AppAction } from 'src/config/authorization.config';
import { TableActionSeverity } from '../types/misc/Severity';

/**
 * Represents the configuration for a generic row action.
 */
export class GenericRowActionConfiguration {
  /**
   * The icon associated with the action.
   * For example a pencil icon for an edit action.
   */
  icon!: string;

  /**
   * Indicates if the action should be displayed as an icon only.
   */
  iconOnly!: boolean;

  /**
   * The translation key for the tooltip.
   */
  tooltipTranslateKey!: string;

  /**
   * The unique identifier for the action.
   * This is used to identify the action in the "rowActionClicked" event of the generated component.
   */
  identifier!: string;

  /**
   * The color of the action (icon / border).
   */
  color!: string;

  /**
   * The text color of the action.
   */
  textColor?: string;

  /**
   * Indicates if confirmation is required for the action.
   * If true, a confirmation dialog will be displayed before the action is executed.
   */
  confirmRequired?: boolean;

  /**
   * The path to the asset associated with the action.
   * For example, the path to an image asset. (e.g. for showing a flag ('de' or 'en'))
   */
  assetPath?: string;

  /**
   * The permission action(s) required to perform the action.
   */
  permissionAction?: AppAction | AppAction[] | undefined = undefined;

  /**
   * The severity level of the action.
   */
  severity: TableActionSeverity = 'primary';

  /**
   * Indicates if the action icon should be displayed with full color.
   * if false, the <app-table-action></app-table-action> component will be shown
   *  ToDo: CHANGE THIS BEHAVIOR
   */
  fullColor?: boolean;

  /**
   * Constructs a new instance of GenericRowActionConfiguration.
   *
   * @param {Partial<GenericRowActionConfiguration>} [config] - An optional partial configuration object to initialize the instance.
   */
  constructor(config?: Partial<GenericRowActionConfiguration>) {
    Object.assign(this, config);

    this.iconOnly = this.iconOnly ?? false;
    this.fullColor = this.fullColor ?? false;
  }
}
